import Contract from './Contract.json';

export default {
  Contract,
};
